import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

function fmtINR(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n);
}

export default function WalletsPage() {
  const ref = useRefData();

  const columns = [
    {
      key: "wallet_number",
      label: "Wallet #",
      render: (w) => (
        <Link to={`/wallets/${w.id}`} className="font-mono text-xs text-emerald-400 hover:underline" data-testid={`wallets-num-${w.id}`}>
          {w.wallet_number}
        </Link>
      ),
    },
    {
      key: "holder_name",
      label: "Holder",
      render: (w) => (
        <Link to={`/wallets/${w.id}`} className="text-white hover:text-sky-300 transition-colors">{w.holder_name}</Link>
      ),
    },
    {
      key: "user_id",
      label: "Tagged User",
      render: (w) => {
        const u = (ref.users || []).find((x) => x.value === w.user_id);
        return <span className="text-zinc-400 text-xs">{u?.label || <span className="text-zinc-600">—</span>}</span>;
      },
    },
    { key: "opening_balance", label: "Opening", render: (w) => <span className="font-mono text-zinc-300">{fmtINR(w.opening_balance)}</span> },
    { key: "unsettled_total", label: "Unsettled", render: (w) => <span className="font-mono text-amber-300">{fmtINR(w.unsettled_total || 0)}</span> },
    { key: "closing_balance", label: "Closing", render: (w) => <span className="font-mono text-emerald-300">{fmtINR(w.closing_balance)}</span> },
  ];

  const fields = [
    { key: "wallet_number", label: "Wallet Number", required: true },
    { key: "holder_name", label: "Wallet Holder Name", required: true },
    { key: "user_id", label: "Tag to User (optional, unique)", type: "select", optionsRef: "users" },
    { key: "opening_balance", label: "Opening Balance (₹)", type: "number" },
  ];

  const initial = { wallet_number: "", holder_name: "", user_id: "", opening_balance: 0 };

  return (
    <EntityPage
      title="Wallets"
      subtitle="Per-user wallets tracking opening balance, credits/debits and running balance."
      testidPrefix="wallets"
      endpoint="/wallets"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
